/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BoughtCouponDto } from './boughtCouponDto';


export interface StaffCouponActionDto { 
    id?: number;
    uuid?: string;
    created?: string;
    action?: StaffCouponActionDto.ActionEnum;
    couponStatus?: StaffCouponActionDto.CouponStatusEnum;
    loyaltyCoupon?: BoughtCouponDto;
}
export namespace StaffCouponActionDto {
    export type ActionEnum = 'SCAN_COUPON' | 'REDEEM_COUPON';
    export const ActionEnum = {
        ScanCoupon: 'SCAN_COUPON' as ActionEnum,
        RedeemCoupon: 'REDEEM_COUPON' as ActionEnum
    };
    export type CouponStatusEnum = 'ACTIVE' | 'EXPIRED' | 'REDEEMED' | 'TO_BE_REDEEMED' | 'CANCELLED';
    export const CouponStatusEnum = {
        Active: 'ACTIVE' as CouponStatusEnum,
        Expired: 'EXPIRED' as CouponStatusEnum,
        Redeemed: 'REDEEMED' as CouponStatusEnum,
        ToBeRedeemed: 'TO_BE_REDEEMED' as CouponStatusEnum,
        Cancelled: 'CANCELLED' as CouponStatusEnum
    };
}


